import { setFields } from "@helpers/functions";
import { Contact } from "./contact";
import { ErrorClass, ResponseError } from "bp-common-models-lib";

export {
	ResponseError,
	ErrorClass,
	HttpErrorResponseCustom,
	UnauthorizedError,
	BadRequestError,
	ForbiddenError,
	LimitError,
	ValidationError,
	InternalServerError,
	NotFoundError,
	DataAlreadyExistsError,
	VerificationError,
	OfflineError,
	GoneError,
	PasswordValidationError
} from "bp-common-models-lib";

export class PossibleInternalTx extends ErrorClass {
	public name = "PossibleInternalTx";

	public constructor(
		public message: string,
		public responseErrors?: ResponseError[]
	) {
		super(message, responseErrors);
		setFields(this._contact, responseErrors[0]["meta"]["contact"]);
	}

	public _contact: Contact = new Contact();

	public get contact(): Contact {
		return this._contact;
	}
}

export class InviteTx extends PossibleInternalTx {
	public name = "InviteTx";

	public constructor(
		public message: string,
		public responseErrors?: ResponseError[]
	) {
		super(message, responseErrors);
	}
}

export class LegalRightsRevokedError extends ErrorClass {
	public name = "LegalRightsRevoked";

	public constructor(
		public message: string,
		public responseErrors?: ResponseError[]
	) {
		super(message, responseErrors);
	}
}

export class RequestTimeout extends ErrorClass {
	public name = "RequestTimeout";

	public constructor(
		public message: string,
		public responseErrors?: ResponseError[]
	) {
		super(message, responseErrors);
	}
}
